import {faEye} from "@fortawesome/free-solid-svg-icons";

export default faEye;
